import { createContext, type SetStateAction, useContext } from "react";
import { type IMovieActivity } from "src/lib/filmwebid/IMovieActivity";

export type MovieActivityContextType = {
    activity: IMovieActivity | null | undefined;
    activityUpdater: () => void;
    optimisticUpdater: (activity: SetStateAction<IMovieActivity | undefined>) => void;
    isLoading: boolean;
}

export const MovieActivityContext = createContext<MovieActivityContextType>({
    activity: null,
    activityUpdater: () => { },
    optimisticUpdater: () => { },
    isLoading: false
});

export function useMovieActivityContext() {
	return useContext(MovieActivityContext);
}